import { useMemo, useRef } from 'react';
import type { SecurityRead } from 'api';
import { OPTION, WARRANT } from 'common/constants/securityTypes';

/**
 * The hidden convertible-note columns among the securities, as the same array until one of them changes.
 * The grid rebuilds its sheet whenever this array changes, so a patch to another security must not hand it a new
 * one: that rebuild would run before the grid's columns catch up with the patch and show the old values.
 */
const useHiddenNoteColumns = (securities: SecurityRead[] | undefined): SecurityRead[] => {
  const previous = useRef<SecurityRead[]>([]);
  return useMemo(() => {
    const next = (securities ?? []).filter(s => s.is_hidden && ![WARRANT, OPTION].includes(Number(s.security_type)));
    const unchanged = next.length === previous.current.length && next.every((s, i) => s === previous.current[i]);
    if (!unchanged) {
      previous.current = next;
    }
    return previous.current;
  }, [securities]);
};

export default useHiddenNoteColumns;
